import {
  DEFAULT_BETWEEN_ROUND_TROPHY,
  DEFAULT_STARTS_IN_TROPHY,
  getDefaultTocTrophy,
  getDefaultTocTrophyVariant,
} from '../../../../stores/tournament/constants';

export const CHAMPIONS_WIDGET_TROPHY_MODE = {
  BETWEEN_ROUNDS: 'between-rounds',
  ACTIVE_ROUND: 'active-round',
} as const;

export type ChampionsWidgetTrophyMode =
  (typeof CHAMPIONS_WIDGET_TROPHY_MODE)[keyof typeof CHAMPIONS_WIDGET_TROPHY_MODE];

export type ChampionsWidgetTrophyPresentation = {
  mode: ChampionsWidgetTrophyMode;
  src: string;
  variant: number | null;
  isOnFinalRound: boolean;
  isCountdown: boolean;
};

type ResolveChampionsWidgetTrophyPresentationParams = {
  isCountdown: boolean;
  isActiveRound: boolean;
  isBetweenRounds: boolean;
  isSummaryWidget: boolean;
  playerRank: number | null;
  widgetIcon: string | null;
  betweenRoundsWidgetImg: string | null;
  currentRoundIndex: number;
  roundsCount: number;
  isOnFinalRound: boolean;
};

export function resolveChampionsWidgetTrophyPresentation({
  isCountdown,
  isActiveRound,
  isBetweenRounds,
  isSummaryWidget,
  playerRank,
  widgetIcon,
  betweenRoundsWidgetImg,
  currentRoundIndex,
  roundsCount,
  isOnFinalRound,
}: ResolveChampionsWidgetTrophyPresentationParams): ChampionsWidgetTrophyPresentation | null {
  if (isCountdown) {
    return {
      mode: CHAMPIONS_WIDGET_TROPHY_MODE.ACTIVE_ROUND,
      src: widgetIcon ?? DEFAULT_STARTS_IN_TROPHY,
      variant: null,
      isOnFinalRound: false,
      isCountdown: true,
    };
  }

  const isUnacknowledgedActiveRound = isActiveRound && playerRank === null;

  if (isBetweenRounds || isSummaryWidget || isUnacknowledgedActiveRound) {
    const src = isUnacknowledgedActiveRound
      ? (betweenRoundsWidgetImg ?? DEFAULT_BETWEEN_ROUND_TROPHY)
      : (widgetIcon ?? betweenRoundsWidgetImg ?? DEFAULT_BETWEEN_ROUND_TROPHY);

    return {
      mode: CHAMPIONS_WIDGET_TROPHY_MODE.BETWEEN_ROUNDS,
      src,
      variant: null,
      isOnFinalRound: false,
      isCountdown: false,
    };
  }

  if (!isActiveRound || !widgetIcon) return null;

  return {
    mode: CHAMPIONS_WIDGET_TROPHY_MODE.ACTIVE_ROUND,
    src: widgetIcon,
    variant: getDefaultTocTrophyVariant(currentRoundIndex, roundsCount),
    isOnFinalRound,
    isCountdown: false,
  };
}

export function getChampionsWidgetTrophyFallback(
  presentation: ChampionsWidgetTrophyPresentation,
  currentRoundIndex: number,
  roundsCount: number,
): string {
  if (presentation.isCountdown) return DEFAULT_STARTS_IN_TROPHY;
  if (presentation.mode === CHAMPIONS_WIDGET_TROPHY_MODE.BETWEEN_ROUNDS) return DEFAULT_BETWEEN_ROUND_TROPHY;
  return getDefaultTocTrophy(currentRoundIndex, roundsCount);
}
